import { AxiosResponse } from "axios";
import { all, call, put, takeEvery, takeLatest } from "redux-saga/effects";

import * as actions from "./actions";
import * as actionTypes from "./actionTypes";
import * as types from "./types";
import * as services from "./service";
import * as alert from "../alert/actions";


function* fetchTaskListSaga(action: types.FetchTaskListReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IDataTaskList> = yield call(services.getDataTaskList, action.params);

        yield put(
            actions.fetchTaskListSuccess({
                tasks: response.data,
            })
        );

    } catch (e: any) {
        yield put(
            actions.fetchTaskListFailure({
                error: e,
            })
        );
        yield put(alert.enqueueSnackbar({ message: `Could not load extractors. Timestamp: ${timestamp}`, options: { variant: "error" } }));
    }
}

function* fetchLoaderListSaga(action: types.FetchLoaderListReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IDataLoaderList> = yield call(services.getLoaderList, action.params);

        yield put(
            actions.fetchLoaderListSuccess({
                getLoaders: response.data,
            })
        );

    } catch (e: any) {
        yield put(
            actions.fetchLoaderListFailure({
                error: e,
            })
        );
        yield put(alert.enqueueSnackbar({ message: `Could not load loaders. Timestamp: ${timestamp}`, options: { variant: "error" } }));
    }
}

function* fetchEventTaskListSaga(action: types.FetchEventTaskListReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IDataEventTaskList> = yield call(services.getDataEventTaskList, action.params);

        yield put(
            actions.fetchEventTaskListSuccess({
                eventTasks: response.data,
            })
        );

    } catch (e: any) {
        yield put(
            actions.fetchEventTaskListFailure({
                error: e,
            })
        );
        yield put(alert.enqueueSnackbar({ message: `Could not load event tasks. Timestamp: ${timestamp}`, options: { variant: "error" } }));
    }
}


function* fetchEventListSaga(action: types.FetchEventListReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IEventList> = yield call(services.getEventList, action.params);

        yield put(
            actions.fetchEventListSuccess({
                events: response.data,
            })
        );

    } catch (e: any) {
        yield put(
            actions.fetchEventListFailure({
                error: e,
            })
        );
        yield put(alert.enqueueSnackbar({ message: `Could not load events. Timestamp: ${timestamp}`, options: { variant: "error" } }));
    }
}

function* fetchInboundListSaga(action: types.FetchInboundListReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IInboundList> = yield call(services.getInboundList, action.params);

        yield put(
            actions.fetchInboundListSuccess({
                inboundEvents: response.data,
            })
        );

    } catch (e: any) {
        yield put(
            actions.fetchInboundListFailure({
                error: e,
            })
        );
        yield put(alert.enqueueSnackbar({ message: `Could not load inbound events. Timestamp: ${timestamp}`, options: { variant: "error" } }));
    }
}


function* postTaskSaga(action: types.PostTaskRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPostTaskSuccess | types.IApiError> = yield call(services.postTask, action.payload);
        if (response.status === 201) {
            let dataPayload = response.data as types.IPostTaskSuccess;
            yield put(
                actions.postTaskSuccess({
                    taskId: dataPayload
                })
            );
            // yield put(alert.enqueueSnackbar({ message: "Event task successfully created", options: { variant: "success" } }));
        }

        //Show IApiError
        if (response.status !== 201) {
            let apiError = response.data as types.IApiError;
            yield put(
                actions.postTaskFailure({
                    error: apiError,
                })
            );
        }
    } catch (e: any) {
        yield put(
            actions.postTaskFailure({
                error: e.message,
            })
        );
    }
}

function* fetchTaskConnectionSaga(action: types.FetchTaskConnectionReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.TaskConnectionList> = yield call(services.getTaskConnection, action.params);

        yield put(
            actions.fetchTaskConnectionSuccess({
                taskConnection: response.data,
            })
        );

    } catch (e: any) {
        yield put(
            actions.fetchTaskConnectionFailure({
                error: e,
            })
        );
        yield put(alert.enqueueSnackbar({ message: `${e}, Timestamp: ${timestamp}`, options: { variant: "error" } }));
    }
}


function* fetchOutboundListSaga(action: types.FetchOutboundListReq) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IOutboundList> = yield call(services.getOutboundList, action.params);

        yield put(
            actions.fetchOutboundListSuccess({
                outboundEvents: response.data,
            })
        );

    } catch (e: any) {
        yield put(
            actions.fetchOutboundListFailure({
                error: e,
            })
        );
        yield put(alert.enqueueSnackbar({ message: `Could not load outbound events. Timestamp: ${timestamp}`, options: { variant: "error" } }));
    }
}

function* postTaskConnectionSaga(action: types.PostTaskConnectionRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPostTaskConnectionSuccess | types.IApiError> = yield call(services.postTaskConnection, action.payload);
        if (response.status === 201) {
            let dataPayload = response.data as types.IPostTaskConnectionSuccess;
            yield put(
                actions.postTaskConnectionSuccess({
                    taskConnectionId: dataPayload
                })
            );
        }

        //Show IApiError
        if (response.status !== 201) {
            let apiError = response.data as types.IApiError;
            let errmsg = `StatusCode:${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(
                actions.postTaskConnectionFailure({
                    error: apiError,
                })
            );
        }
    } catch (e: any) {
        yield put(
            actions.postTaskConnectionFailure({
                error: e.message,
            })
        );
    }
}

function* putTaskSaga({ taskId, payload }: types.PutTaskRequest) {
    const timestamp = new Date().toLocaleString();
    try {
        const response: AxiosResponse<types.IPutTaskSuccess | types.IApiError> = yield call(services.editTask, taskId, payload);

        if (response.status === 204) {
            let dataPayload = response.data as types.IPutTaskSuccess;
            yield put(
                actions.putTaskSuccess({
                    task: dataPayload
                })
            );
            let successMsg = `Task successfully edited. Timestamp: ${timestamp}`;
            yield put(alert.enqueueSnackbar({ message: successMsg, options: { variant: "success" } }));
        }
        if (response.status !== 204) {
            let apiError = response.data as types.IApiError;
            let errMsg = `StatusCode: ${apiError.errorCode} - ${apiError.errorType}. Details: ${apiError.detail}. Timestamp: ${timestamp}`;
            yield put(
                actions.putTaskFailure({
                    error: apiError,
                })
            );
            yield put(alert.enqueueSnackbar({ message: errMsg, options: { variant: "error" } }));

        }
    } catch (e: any) {
        yield put(
            actions.putTaskFailure({
                error: e,
            })
        );
    }
}

/*
  Watcher saga - intercept the action fired from view
  Starts worker saga on latest dispatched `FETCH_ACCESSCONTROL_REQUEST` action.
  Allows concurrent increments.
*/


function* taskListSaga() {
    yield takeLatest(actionTypes.FETCH_TASK_LIST_REQUEST, fetchTaskListSaga);
}

function* loaderListSaga() {
    yield takeLatest(actionTypes.FETCH_LOADER_LIST_REQUEST, fetchLoaderListSaga);
}

function* eventTaskListSaga() {
    yield takeLatest(actionTypes.FETCH_EVENT_TASK_LIST_REQUEST, fetchEventTaskListSaga);
}

function* eventListSaga() {
    yield takeLatest(actionTypes.FETCH_EVENT_LIST_REQUEST, fetchEventListSaga);
}

function* inboundListSaga() {
    yield takeLatest(actionTypes.FETCH_INBOUND_LIST_REQUEST, fetchInboundListSaga);
}

function* outboundListSaga() {
    yield takeLatest(actionTypes.FETCH_OUTBOUND_LIST_REQUEST, fetchOutboundListSaga);
}

function* postTaskListSaga() {
    yield takeEvery(actionTypes.POST_TASK_REQUEST, postTaskSaga);
}

function* postTaskConnectionsSaga() {
    yield takeEvery(actionTypes.POST_TASK_CONNECTION_REQUEST, postTaskConnectionSaga);
}

function* taskConnectionSaga() {
    yield takeEvery(actionTypes.FETCH_TASK_CONNECTION_REQUEST, fetchTaskConnectionSaga);
}

function* editTaskSaga() {
    yield takeEvery(actionTypes.PUT_TASK_REQUEST, putTaskSaga)
}


function* dataTaskSaga() {
    yield all([
        taskListSaga(),
        eventTaskListSaga(),
        postTaskConnectionsSaga(),
        loaderListSaga(),
        taskConnectionSaga(),
        eventListSaga(),
        inboundListSaga(),
        postTaskListSaga(),
        outboundListSaga(),
        editTaskSaga()
    ])
};

export default dataTaskSaga;
